import React from 'react';
import { FiPlus } from 'react-icons/fi';

const PosSlotGrid = ({
  slots = [],
  onSelect,
  onAddSlot,
  showAddSlot = false,
  emptyLabel = 'No hay favs configurados.',
  variant = 'default',
}) => {
  const hasSlots = Array.isArray(slots) && slots.length > 0;
  const isCompact = variant === 'compact';

  return (
    <div className={isCompact
      ? 'grid grid-cols-3 gap-2 md:grid-cols-4 xl:grid-cols-6 2xl:grid-cols-8'
      : 'grid grid-cols-3 gap-2 sm:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 2xl:grid-cols-10'}
    >
      {!hasSlots && !showAddSlot && (
        <div className="col-span-full rounded-2xl border border-dashed border-gray-300 bg-white px-6 py-12 text-center text-sm text-gray-500">
          {emptyLabel}
        </div>
      )}

      {(slots || []).map((slot) => (
        <button
          type="button"
          key={slot.key}
          onClick={() => !slot.disabled && onSelect?.(slot)}
          disabled={slot.disabled}
          title={slot.invalidReason || slot.productName}
          className={`relative flex aspect-square flex-col items-center justify-center overflow-hidden rounded-2xl border bg-white text-center shadow-sm transition ${
            slot.disabled
              ? 'cursor-not-allowed border-gray-200 opacity-80 grayscale'
              : 'border-gray-200 hover:border-blue-200 hover:shadow-md'
          } p-2`}
        >
          {slot.imageSrc ? (
            <img
              src={slot.imageSrc}
              alt={slot.productName}
              className={`${isCompact ? 'h-11 w-11 rounded-xl' : 'h-16 w-16 rounded-2xl'} object-cover shadow-sm`}
            />
          ) : (
            <div className={`flex items-center justify-center bg-gray-100 text-gray-400 ${
              isCompact ? 'h-11 w-11 rounded-xl' : 'h-16 w-16 rounded-2xl'
            }`}>
              {slot.productName?.charAt(0)?.toUpperCase() || '?'}
            </div>
          )}

          <div
            className={`mt-2 w-full overflow-hidden px-1 font-semibold leading-tight text-gray-900 ${
              isCompact ? 'text-xs' : 'text-xs sm:text-sm'
            }`}
            style={{
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 2,
            }}
          >
            {slot.productName}
          </div>
        </button>
      ))}

      {showAddSlot && (
        <button
          type="button"
          onClick={() => onAddSlot?.()}
          className="flex aspect-square flex-col items-center justify-center rounded-2xl border border-dashed border-blue-300 bg-blue-50 px-2 py-3 text-center text-blue-700 transition hover:bg-blue-100"
        >
          <span className={`flex items-center justify-center rounded-full bg-white text-blue-700 shadow-sm ${isCompact ? 'h-10 w-10' : 'h-12 w-12'}`}>
            <FiPlus size={20} />
          </span>
        </button>
      )}
    </div>
  );
};

export default PosSlotGrid;
